module.exports = __webpack_public_path__ + "img/icon-warning-drivingconditions-3.a2000c4f.svg";